// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__QBRUK","success":"styles_success__0OLhz","error":"styles_error__Hj6Ao"};